import { NgClass, NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, Input, OnInit, Signal } from '@angular/core';
import { Services } from '@app/services/enums/services.enum';
import { TransactionStore } from '@app/transaction/store/transaction.store';
import { StringUtils } from '@core/utils';
import { TranslateModule } from '@ngx-translate/core';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { HelpItem, helpItems } from './service-submitted.constants';

@Component({
    selector: 'app-service-submitted',
    standalone: true,
    imports: [NgOptimizedImage, TranslateModule, InlineSVGModule, NgClass],
    template: `
        <div class="grid md:grid-cols-2 gap-6">
            <div [ngClass]="{ 'md:col-span-1': showHelp, 'md:col-span-2 md:mx-auto': !showHelp }">
                <div class="u-flex-column">
                    <img
                        class="mx-auto"
                        ngSrc="https://assets.smooved.be/illustrations/v2/spot/processed.webp"
                        width="100"
                        height="100"
                        [priority]="true"
                    />
                    <p class="text-title-md text-center mb-1">{{ baseLabel + (diy ? '.DIY_TITLE' : '.TITLE') | translate }}</p>
                    <p class="text-body-md text-secondary text-center">{{ baseLabel + '.TEXT' | translate }}</p>
                </div>
            </div>
            @if (showHelp) {
                <div class="mt-10 md:mt-0">
                    <p class="text-secondary mb-1 text-ui-md">{{ baseLabel + '.HELP.TITLE' | translate }}</p>
                    @for (item of helpItems; track item.linkTranslationKey) {
                        <a
                            [href]="item.linkTranslationKey | translate: { moveId: transactionStore.transactionId() }"
                            target="_blank"
                            class="flex items-center py-3 justify-between border-b border-on-surface-default last:border-b-0 last:pb-0"
                        >
                            <div class="flex items-center gap-3">
                                <span class="text-ui-md">{{ item.labelTranslationKey | translate }}</span>
                            </div>
                            <div inlineSVG="https://assets.smooved.be/icons/v2/20/chevron-right.svg"></div>
                        </a>
                    }
                </div>
            }
        </div>
    `,

    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ServiceSubmittedComponent implements OnInit {
    @Input() public showHelp: boolean = false;
    @Input() public service: Services = Services.EnergyStop;
    @Input() public diy: boolean;

    public readonly transactionStore = inject(TransactionStore);

    protected helpItems: HelpItem[];
    protected baseLabel: string;

    public ngOnInit(): void {
        this.helpItems = helpItems[this.service];
        this.baseLabel = `V2.SERVICES.${StringUtils.toUpperSnakeCase(this.service)}.SUBMITTED`;
    }
}
